import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#4f537e",
	},
});

const CashVoucherAllocate = () => {
	const { cvno, branchidno } = useParams();
	const [fundFrom, setFundFrom] = useState([]);
	const [payTo, setPayTo] = useState('');
	const [amount, setAmount] = useState('');
	const [notes, setNotes] = useState('');
	const classes = useStyles();
	// const [poTotal, setPoTotal] = useState(0);

	const [cvDate, setCvDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	const [fundsDate, setFundsDate] = React.useState(format(new Date(), "yyyy-MM-dd"));

	const [accountIndex, setAccountIndex] = useState(null);

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	const [status, setStatus] = useState("");
	const [approver, setApprover] = useState("");
	const [allocationType, setAllocationType] = useState("");

	const [supplier, setSupplier] = useState([]);
	const [supplierId, setSupplierId] = useState('');
	
	let history = useHistory();

	useEffect(() => {
		getCashVoucherDetails();
		getSupplierList();
	}, []);

	const checkType = [
		{
			type:'Petty Cash'
		},
		{
			type:'Cash Sales'
		}
	]
	const allocationTypes = [
		{
			type:'Purchases'
		},
		{
			type:'Expenses'
		}
	]
	const checkSupplierProps = {
		options: checkType,
		getOptionLabel: (option) => option.type,
	};
	const checkAllocProps = {
		options: allocationTypes,
		getOptionLabel: (option) => option.type,
	};

	
	const getSupplierList = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'/get_supplier_list', {
			params:{
				jc_user_id_no: branchidno,  //branchIdNo
			}
		});
		setSupplier(result.data.data);
	}
	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.suppliername,
	};
	const setSupplierDetails = (supplier_object) => {
		//update value of supplier address, etc
		console.log(supplier_object); //id filter for PO = supplier_object.id (since its an object)
		setSupplierId(supplier_object.id)
	}

	const getCashVoucherDetails = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'cv_view_allocate', {
			params:{
				cvno: cvno,
				jc_u_idno: branchidno
			}
		}).then((res)=>{
			setPayTo(res.data.data[0].payto);
			setAmount(res.data.data[0].released_amount);
			setNotes(res.data.data[0].notes);
			setCvDate(res.data.data[0].trandate);
			setFundsDate(res.data.data[0].fundsdate);
			setFundFrom(res.data.data[0].fundfrom);
			setStatus(res.data.data[0].status);
			setApprover(res.data.data[0].approver);
			let fundfrom = res.data.data[0].fundfrom;
			setAccountIndex(checkType.findIndex(check => check.type === fundfrom));
		}).catch((error)=>{
		//console.log(error.message);
		});
	}

	useEffect(() => {
		if(allocationType==="Expenses"){
			setBtnDisabled(false); // re-enable
		}else if(allocationType==="Purchases"){
			if(supplierId){
				setBtnDisabled(false); // re-enable
			}else{
				setBtnDisabled(true);
			}
		}else{
			setBtnDisabled(true);
		}
	}, [allocationType,supplierId]);

	const handleCashDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setCvDate(date);
		
	};
	const handleFundsDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setFundsDate(date);
	};

	const proceedToAllocation = () => {
		if(allocationType==="Expenses"){
			history.push("/account/cash-voucher-allocate-e/"+cvno);
			//console.log("Expenses");
		}else if(allocationType==="Purchases"){
			history.push("/account/cash-voucher-allocate-p/"+cvno+"/"+branchidno+"/"+supplierId);
			//console.log("Purchases");
		}
	}

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	return (
		<div className="page">

			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/account"}><h4 style={{color:"#339933"}}>Accounts</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/account/cash-voucher-transaction-history"}><h4 style={{color:"#339933"}}>Cash Voucher Listing</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Cash Voucher Allocate #{cvno}</h4>
			</div>
			{accountIndex != null ? (<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid container spacing={2}>
								<Grid item xs="6" lg="5" xl="4">
									<div className={classes.subTitle}>
									Cash Voucher Information
									</div>
									<div className={classes.title}>
									Cash Voucher Information
									</div>
									<form noValidate autoComplete="off">
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Cash Voucher Date"
											value={cvDate}
											onChange={handleCashDateChange}
											inputVariant="outlined"
											margin="normal"
											disabled={true}
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}/>
										</MuiPickersUtilsProvider>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Funds Date"
											value={fundsDate}
											onChange={handleFundsDateChange}
											inputVariant="outlined"
											margin="normal"
											disabled={true}
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}/>
										</MuiPickersUtilsProvider>
										<Autocomplete
													{...checkSupplierProps}
													id="auto-complete"
													autoComplete
													includeInputInList
													defaultValue={checkType[accountIndex]}
													className={classes.autoComplete}
													disabled={true}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Select Account"
															margin="normal"
															variant="outlined"
														/>
													)}
													onChange={(event, newValue) => {
														if (!newValue == "" || !newValue == null){
															console.log(newValue);
															setFundFrom(newValue.type);
														}
													}}
										/>
										<TextField
													style={{marginTop:"8px"}}
													id="outlined-required"
													label="Pay To"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={payTo} //to avoid label overlapping bug
													onChange={(e)=>{setPayTo(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>	
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Amount"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={amount} //to avoid label overlapping bug
													onChange={(e)=>{setAmount(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Approver"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={approver} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Status"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={status} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Notes"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={notes} //to avoid label overlapping bug
													onChange={(e)=>{setNotes(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
											</form>
								</Grid>
								{/* Allocation Information */}
								<Grid item xs="6" lg="6" xl="6">
									<div className={classes.subTitle}>
									Allocation Information
									</div>
									<div className={classes.title}>
									Allocation Information
									</div>
									<form noValidate autoComplete="off">
										<Autocomplete
													{...checkAllocProps}
													id="auto-complete"
													autoComplete
													includeInputInList
													className={classes.autoComplete}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Select Allocation Type"
															margin="normal"
															variant="outlined"
														/>
													)}
													onChange={(event, newValue) => {
														if (!newValue == "" || !newValue == null){
															console.log(newValue);
															setAllocationType(newValue.type);
														}
													}}
										/>
										{allocationType === "Purchases" ? (<Autocomplete
											{...selectSupplierProps}
											id="auto-complete"
											autoComplete
											includeInputInList
											className={classes.autoComplete}
											renderInput={(params) => (
												<TextField
													{...params}
													label="Select Supplier"
													margin="normal"
													variant="outlined"
												/>
											)}
											onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													console.log(newValue);
													setSupplierDetails(newValue);
												}
											}}
										/>) : (<></>)}
										
										
										<div className={classes.buttonContainer}>
											<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{proceedToAllocation()}}>
												Allocate
											</Button> 
										</div>
											</form>
								</Grid>
					        </Grid>
						</Grid>
					</div>	
					</Card>				
					{/* <div className={classes.buttonContainer}>
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{approve_cv()}}>
						Approve
					</Button> 
					</div>*/}
			</div>) : (<div></div>)}
		</div>
	);
};

export default CashVoucherAllocate;
